// Product page: replaces the size label + native dropdown with a single "SIZE" button.
// Tapping it opens the list of sizes; picking one shows it on the button.
// Add to cart / Buy it now open the list first if no size has been picked yet.
(function () {
  var chevron = '<svg aria-hidden="true" focusable="false" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.2"/></svg>';

  function build(input, n) {
    var select = input.querySelector('select');
    var label = input.querySelector('.form__label');
    if (!select || input.querySelector('.size-dd')) return;
    var name = (label ? label.textContent : select.name.replace(/^options\[|\]$/g, '')).trim();

    var wrap = document.createElement('div');
    wrap.className = 'size-dd';
    var listId = 'SizeList-' + n + '-' + Math.random().toString(36).slice(2, 7);
    wrap.innerHTML =
      '<button type="button" class="size-dd__button" aria-haspopup="listbox" aria-expanded="false" aria-controls="' + listId + '">' +
      '<span class="size-dd__value"></span>' + chevron + '</button>' +
      '<ul class="size-dd__list" id="' + listId + '" role="listbox" aria-label="' + name + '" hidden></ul>';
    input.appendChild(wrap);
    input.classList.add('has-size-dd');

    var button = wrap.querySelector('.size-dd__button');
    var valueEl = wrap.querySelector('.size-dd__value');
    var list = wrap.querySelector('.size-dd__list');
    wrap.dataset.chosen = '';
    valueEl.textContent = name.toUpperCase();

    function render() {
      list.innerHTML = '';
      Array.prototype.forEach.call(select.options, function (opt) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'size-dd__option';
        b.setAttribute('role', 'option');
        b.dataset.value = opt.value;
        b.textContent = opt.textContent.trim();
        var unavailable = opt.disabled || /unavailable|sold out/i.test(opt.textContent);
        if (unavailable) { b.disabled = true; b.classList.add('is-unavailable'); }
        if (wrap.dataset.chosen && opt.value === select.value) b.setAttribute('aria-selected', 'true');
        li.appendChild(b);
        list.appendChild(li);
      });
    }

    function open() {
      document.querySelectorAll('.size-dd__list:not([hidden])').forEach(function (l) {
        if (l !== list) close(l.closest('.size-dd'));
      });
      render();
      list.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
    }

    wrap._open = open;

    button.addEventListener('click', function (e) {
      e.preventDefault();
      if (list.hidden) open(); else close(wrap);
    });

    list.addEventListener('click', function (e) {
      var opt = e.target.closest('.size-dd__option');
      if (!opt || opt.disabled) return;
      e.preventDefault();
      select.value = opt.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      wrap.dataset.chosen = 'true';
      wrap.classList.remove('needs-choice');
      valueEl.textContent = opt.dataset.value.toUpperCase();
      close(wrap);
      button.focus({ preventScroll: true });
    });
  }

  function close(wrap) {
    if (!wrap) return;
    var list = wrap.querySelector('.size-dd__list');
    var button = wrap.querySelector('.size-dd__button');
    list.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    wrap.classList.remove('is-open');
  }

  function init() {
    var n = 0;
    document.querySelectorAll('product-info variant-selects .product-form__input--dropdown').forEach(function (input) {
      var sel = input.querySelector('.select');
      if (!sel || sel.classList.contains('hidden')) return; // leave colour swatches alone
      build(input, n++);
    });
  }

  // Ask for a size before adding to cart or buying now
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('product-info [name="add"], product-info [data-buy-now]');
    if (!trigger) {
      if (!e.target.closest('.size-dd')) document.querySelectorAll('.size-dd.is-open').forEach(close);
      return;
    }
    var info = trigger.closest('product-info');
    var missing = info && info.querySelector('.size-dd:not([data-chosen="true"])');
    if (missing) {
      e.preventDefault();
      e.stopImmediatePropagation();
      missing.classList.add('needs-choice');
      if (missing._open) missing._open();
      missing.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.size-dd.is-open').forEach(close);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
